<template>
  <main class="credit-main">
    <section class="available-cards">
      <h2 class="available-cards__ttl">対応カード会社</h2>
      <div class="available-cards__body">
        <img src="/static/img/cards.png" alt="">
      </div>
    </section>

    <section class="credit-info">
      <h3 class="short-ttl">カード番号 <span class="required">必須</span></h3>
      <div class="credit-info__main credit-info__main--justify">
        <input id="cc-number" class="input-text input-text--long" name="cardNumber" type="tel"
               size="20" maxlength="20" placeholder="カード番号(全て数字で入力)" autocomplete="cc-number" v-model="fullCardNumber">
      </div>
    </section>

    <section class="credit-info">
      <h3 class="short-ttl">有効期限 <span class="required">必須</span></h3>
      <div class="credit-info__main">
        <select name="cardExpirationYear" class="input-select" v-model="expired.year">
          <option value="2018">2018</option>
          <option value="2019">2019</option>
          <option value="2020">2020</option>
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
          <option value="2029">2029</option>
          <option value="2030">2030</option>
          <option value="2031">2031</option>
          <option value="2032">2032</option>
          <option value="2033">2033</option>
          <option value="2034">2034</option>
          <option value="2035">2035</option>
        </select>
        <select name="cardExpirationMonth" class="input-select" v-model="expired.month">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </select>
      </div>
    </section>

    <section class="credit-info">
      <h3 class="short-ttl">セキュリティコード <span class="required">必須</span></h3>
      <div class="credit-info__main">
        <input type="text" class="input-text input-text--short" placeholder="000" maxlength="4" v-model="securityCode">
        <p class="credit-info__security-code"><a href="javascript:void(0);" @click="showSecurityCode">セキュリティコードについて</a></p>
      </div>
    </section>

    <section class="credit-info">
      <h3 class="short-ttl">お支払い回数：一括払い</h3>
      <p class="credit-info__sentence">※お支払い回数は一括払いのみとなっております。</p>
    </section>

    <div class="credit-btn">
      <span class="btn-square" @click="confirm_payment()">確定</span>
    </div>
  </main>
</template>

<script>
  import { paymentsWays, merchantId, serviceId, subscriptions_prefix, unlimited_subscriptions_prefix } from '../../../constants';
  import store from '../../../store/store';

  export default {
    title: 'クレジットカード登録 - abceed',
    headerTitle: 'クレジットカード登録',
    description: '',
    keywords: '',
    headerType: 'historyBack',
    data() {
      return {
        expired: {
          year: null,
          month: null
        },
        securityCode: null,
        fullCardNumber: null
      }
    },
    beforeCreate() {
      if (this.$store.getters.directLanding) {
        this.$router.push({ name: 'settingHome'});
      }
    },
    methods: {
      showSecurityCode() {
        this.$store.dispatch('showLightBox', 'aboutSecurity');
      },
      confirm_payment() {
        if (!this.validation()) {
          alert("クレジットカード情報が未入力です。");
          return
        }
        //ハイフンを削除
        const ccNumber = this.fullCardNumber.split("-").join("");
        let monthString = this.expired.month + "";
        if (this.expired.month < 10) {
          monthString = "0" + monthString;
        }
        const ccExpiration = this.expired.year + "" + monthString;

        const redirectUrl = '/?result=unlimitedok';
        const product_id = this.$route.params.id;
        let afterGenerateToken = function(response) { if (response.result === "OK") {
          store.dispatch("upgradeByToken", {
            token: response.tokenResponse.token,
            token_key: response.tokenResponse.tokenKey,
            product_id: product_id
          }).then(data => {
            if (data.result) {
              //購入成功
              //TODO routerが匿名関数内で取得できなかったのでwindow.location.hrefで遷移しているが、可能ならrouter.pushにする
              window.location.href = redirectUrl;
            } else {
              store.dispatch("hideLightBox");
              alert('購入に失敗しました。');
            }
          }).catch(() => {
            store.dispatch("hideLightBox");
            alert('購入に失敗しました。');
          });
        } else {
          store.dispatch("hideLightBox");
          alert('通信に失敗しました。');
        }};
        doSubmit(ccNumber, ccExpiration, this.securityCode, afterGenerateToken);
      },
      validation() {
        return this.fullCardNumber && this.expired.year && this.expired.month && this.securityCode;
      }
    }
  }

  function doSubmit(ccNumber, ccExpiration, securityCode, afterGenerateToken){
    store.dispatch("showLightBox", "loading");
    //トークン生成ロジック呼び出し
    com_sbps_system.generateToken({
      merchantId : merchantId,
      serviceId : serviceId,
      ccNumber : ccNumber,
      ccExpiration : ccExpiration,
      securityCode : securityCode
    }, afterGenerateToken); }

</script>



// WEBPACK FOOTER //
// src/components/campainPage/unlimited/UpgradeCreditCard.vue